

import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
		<div style="text-align: justify;">
			<p class="mb-3">
				Kiom da najbaroj ni havas! Kiel interesaj estas iliaj vivoj!
			</p>

			<p class="mb-3">
				Sed ĉu estas ili konataj al ni? Aŭ vere iliaj vivoj estas sekretaj?
			</p>

			
			<p class="text-center bold mb-3">* * *</p>
			
			
			<p class="mb-3">
				Sub neĝo, silente kaj lante, vegetas herbo, kiu printempe ĝojigos nin per junaj floroj.
			</p>

			<p class="mb-3">
				Sub krusto de arboj vintrumas estontaj papilioj kaj skaraboj; en la grundo kaŝas sin cikadoj, kiuj tiel sonore prikantas niajn varmajn noktojn. 
			</p>

			<p class="mb-3">
				Malgrandaj formikoj pene laboras en niaj parkoj, kortoj, en ajna peceto de libera grundo. 
			</p>

			<p class="mb-3">
				En maro abundas konkoj kaj algoj; ankaŭ ili estas vivaj. Ili purigas la marakvon por ke ni povu ĝui naĝadon en maro. 
				Kaj kiom da mirindaj estaĵoj vivas en marakvo! Ni ne povas ilin vidi, ĉar ili estas tro malgrandaj; ilia vivo restas sekreta por ni; 
				sed kiom belaj ili estas! 
				Kiel feliĉaj estas tiuj, kiuj povas observi la akvan mondon!
			</p>

			<p class="mb-3">
				Kaj pli foraj, pli grandaj akv-anoj: balenoj, lutroj, fiŝoj; leporoj kaj ĝirafoj surgrunde, paseroj kaj libeloj enaere, kaj ĉiuj multegaj, 
				nenombreblaj loĝantoj de nia Tero – ili ja estas niaj najbaroj surplanede! 
			</p>

			<p class="mb-3">
				Ni interesiĝas pri ili nur kiam ili minacas nin aŭ kiam ni povus ilin manĝi aŭ iel ajn uzi; se ili ne gravas por ni en la supraj du sencoj, 
				ni tute ne interesiĝas pri ili. Ilia vivo vere restas por ni sekreta. 
			</p>

			<p class="mb-3">
				Sed, eble, kompreninte ion pri ilia vivo, ni povos fari pli senchava, pli harmonia ankaŭ nian propran vivon?
			</p>
		</div>
    `
  )
}

const itemName = {
  esp: 'Sekreta vivo de niaj najbaroj'
}


const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp,
  }
}

export default item; 